<template>
  <div class="detail_attributes_content">
    <van-divider
      content-position="left"
      v-if="CartItemOpt.ProductAttributeOpt.length > 0"
    >
      {{ tools.GetLanguageValue("public.app.已选择") }}
    </van-divider>
    <div
      class="detail_attributes_items"
      style="width: 70%; margin: 0 auto"
      v-if="CartItemOpt.ProductAttributeOpt.length > 0"
    >
      <div
        class="detail_attributes_name"
        v-for="item in CartItemOpt.ProductAttributeOpt"
        :key="item.Id"
      >
        1 * {{ item.Name }} {{ CartItemOpt.PriceFormat }}
      </div>
    </div>
    <div
      class="detail_params_items"
      v-if="CartItemOpt.ProductRemarkItemsOpt.length > 0"
    >
      <div
        class="detail_params_name"
        v-for="item in CartItemOpt.ProductRemarkItemsOpt"
        :key="item.Id"
      >
        1 * {{ item.Name }} {{ item.PriceFormat }}
      </div>
    </div>
    <div style="height: 40px; width: 100%">
      <van-field :label="tools.GetLanguageValue('public.app.备注') "
      v-model="CartItemOpt.Remarks" style="width: 70%; margin: 0 auto"
      :placeholder="tools.GetLanguageValue('public.app.请输入备注')" />

      <div
        style="width: 100%; text-align: center; position: absolute; bottom: 1px"
      >
        <van-button type="primary" size="small" @click="SaveRemarks">
          {{ tools.GetLanguageValue("public.app.保存") }}
        </van-button>
      </div>
    </div>
    <!-- <div v-if="CartItemOpt.ProductAttributeOpt.length == 0
      " class="detail_attributes_notitems">
      <p>{{ tools.GetLanguageValue("public.app.没有选择要求或者属性") }}</p>
      <svg t="1659185225274" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
        p-id="3480" width="200" height="200">
        <path
          d="M734.208 354.461538a78.769231 78.769231 0 0 1 73.216 49.703385L866.461538 552.881231V787.692308a78.769231 78.769231 0 0 1-78.76923 78.76923H236.307692a78.769231 78.769231 0 0 1-78.76923-78.76923v-231.699693l59.195076-151.433846A78.769231 78.769231 0 0 1 290.107077 354.461538h444.100923z m-355.209846 212.676924H189.046154L189.046154 787.692308a47.261538 47.261538 0 0 0 42.417231 47.02523L236.307692 834.953846h551.384616a47.261538 47.261538 0 0 0 47.02523-42.417231L834.953846 787.692308v-220.553846h-189.952a133.907692 133.907692 0 0 1-266.003692 0z m355.249231-181.169231H290.067692a47.261538 47.261538 0 0 0-41.865846 25.284923l-2.166154 4.765538L199.286154 535.630769h190.306461l-0.039384 0.590769A15.753846 15.753846 0 0 1 409.6 551.384615a102.4 102.4 0 0 0 204.8 0 15.753846 15.753846 0 0 1 14.848-15.753846h196.450462l-47.576616-119.847384a47.261538 47.261538 0 0 0-38.675692-29.538462l-5.238154-0.275692zM286.168615 106.417231l2.166154 2.363077 114.609231 155.254154a15.753846 15.753846 0 0 1-23.158154 21.070769l-2.166154-2.363077-114.60923-155.214769a15.753846 15.753846 0 0 1 23.158153-21.110154z m244.460308-4.017231a15.753846 15.753846 0 0 1 15.438769 12.603077l0.315077 3.150769v155.254154a15.753846 15.753846 0 0 1-31.192615 3.150769l-0.315077-3.150769V118.153846c0-8.664615 7.049846-15.753846 15.753846-15.753846z m265.688615 3.072a15.753846 15.753846 0 0 1 4.962462 19.298462l-1.614769 2.756923-114.333539 155.175384a15.753846 15.753846 0 0 1-26.978461-15.911384l1.575384-2.756923 114.372923-155.21477a15.753846 15.753846 0 0 1 22.016-3.347692z"
          fill="#dbdbdb" p-id="3481"></path>
      </svg>
    </div> -->
  </div>
</template>
<script >
import axios from "../commons/AxiosMethod.js"
import tools from "../commons/tools.js"
import commons from "../commons/commons.js"
import { showToast } from "vant"

export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      tools: tools,
      DetailOrderWindow: false, // 详细信息页面
      CartItemOpt: {
        ProductAttributeOpt: [],
        ProductRemarkItemsOpt: []
      }, // 选中购物车项目

      UserInfo: {} // 用户信息
    }
  },
  name: "App",
  mounted () {
    this.CartItemOpt = this.Model
  },
  props: {
    Model: {}
  },
  components: {},
  methods: {
    // 保存备注
    SaveRemarks () {
      axios.apiMethod(
        "/Store/StoreOrder/SaveRemarks",
        "post",
        {
          Id: this.CartItemOpt.Id,
          Remarks: this.CartItemOpt.Remarks
        },
        (result) => {
          if (result.Code == 200) {
            showToast(tools.GetLanguageValue("public.app.操作成功"))
          }
        },
        (e) => {}
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_attributes_content {
  min-height: 300px;

  .detail_attributes_items,
  .detail_params_items {
    width: calc(100% - 50px);
    margin: 0 auto;
    padding: 5px 0px;
    border-radius: 5px;
    border-bottom: 1px solid #eee;

    .detail_attributes_name,
    .detail_params_name {
      width: calc(100% - 100px);
      margin-left: 5px;
      font-size: 9pt;
    }
  }

  .detail_attributes_notitems {
    width: 100%;
    text-align: center;
  }

  .detail_params_items {
    margin-top: 10px;
  }
}

.content {
  min-height: 300px;

  .content_item {
    .content_item_title {
      width: calc(100% - 100px);
      margin-left: 20px;
      font-size: 15pt;
    }
  }
}
</style>
